import { useEffect } from 'react';

/**
 * Hard-redirects the browser to the marketing site (Astro), preserving the
 * current path. Used for routes that used to live in this SPA but now live
 * on https://kontomatch.com after the marketing/app subdomain split.
 */
export default function MarketingRedirect() {
  useEffect(() => {
    const base = process.env.REACT_APP_MARKETING_URL || 'https://kontomatch.com';
    const dest = `${base}${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.replace(dest);
  }, []);

  return null;
}
